import { useState, useEffect } from 'react';
import { X, Share } from 'lucide-react';
import { usePWA } from '../contexts/PWAContext';
import { BRAND_NAME } from '../constants/brand';

export function IOSAddToHomeScreen() {
  const { isPromptVisible, dismissInstallPrompt, isFabPresent } = usePWA();
  const [isIOS, setIsIOS] = useState(false);
  const [isInstalled, setIsInstalled] = useState(false);

  useEffect(() => {
    const checkIOSAndInstallStatus = () => {
      const isiOS = /iphone|ipad|ipod/i.test(window.navigator.userAgent);

      // Check for PWA standalone mode (standard way + WebKit fallback)
      const isInStandaloneMode = window.matchMedia('(display-mode: standalone)').matches ||
                                 !!(window.navigator as { standalone?: boolean }).standalone;

      setIsIOS(isiOS);
      setIsInstalled(isInStandaloneMode);
    };

    checkIOSAndInstallStatus();
  }, []);

  const handleDismiss = () => {
    dismissInstallPrompt();
  };

  // Only show on iOS Safari, not already installed, and when context says to show.
  // Suppress while a FAB is on screen (#3096) — the FAB is a core Action-layer
  // control and this z-50 card would otherwise cover it.
  if (!isPromptVisible || !isIOS || isInstalled || isFabPresent) return null;

  return (
    <div className="fixed bottom-20 left-4 right-4 z-50 md:left-auto md:right-4 md:max-w-sm">
      <div className="bg-oro-bg border border-accent/20 rounded-lg p-4 shadow-xl backdrop-blur-sm">
        <div className="flex items-start justify-between mb-3">
          <div className="flex items-center space-x-2">
            <div className="w-8 h-8 bg-accent rounded-lg flex items-center justify-center font-bold text-black text-sm">
              O
            </div>
            <h3 className="text-text-primary font-semibold text-sm">Add ORO to Home Screen</h3>
          </div>
          <button
            onClick={handleDismiss}
            className="text-text-muted hover:text-text-primary transition-colors p-1"
            type="button"
          >
            <X size={16} />
          </button>
        </div>

        <p className="text-text-secondary text-xs mb-3">
          Access {BRAND_NAME} instantly from your home screen.
        </p>

        <div className="flex items-center space-x-2 mb-3 p-2 bg-accent/10 rounded-lg border border-accent/20">
          <Share size={16} className="text-accent flex-shrink-0" />
          <div>
            <p className="text-text-primary text-xs font-medium">
              Tap the Share button below
            </p>
            <p className="text-text-muted text-xs">
              Then select &ldquo;Add to Home Screen&rdquo;
            </p>
          </div>
        </div>

        <button
          onClick={handleDismiss}
          type="button"
          className="w-full bg-oro-surface-alt hover:bg-oro-surface border border-oro-border text-text-primary font-medium py-2 px-4 rounded-lg transition-colors text-sm"
        >
          Got it
        </button>
      </div>
    </div>
  );
}
